import { useState, useCallback } from "react";

export interface UseDrawerReturn {
  mobileOpen: boolean;
  desktopOpen: boolean;
  handleDrawerToggle: () => void;
  handleDesktopToggle: () => void;
  setMobileOpen: (open: boolean) => void;
  setDesktopOpen: (open: boolean) => void;
}

export const useDrawer = (initialDesktopOpen = true): UseDrawerReturn => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(initialDesktopOpen);

  const handleDrawerToggle = useCallback(() => {
    setMobileOpen((prev) => !prev);
  }, []);

  const handleDesktopToggle = useCallback(() => {
    setDesktopOpen((prev) => !prev);
  }, []);

  return {
    mobileOpen,
    desktopOpen,
    handleDrawerToggle,
    handleDesktopToggle,
    setMobileOpen,
    setDesktopOpen,
  };
};
